import api from './apiService';

class Agreement {
  static get() {
    return api.get('/agreements');
  }
}

export default Agreement;



// WEBPACK FOOTER //
// ./src/api/agreementApi.js